import React, { useEffect, useRef } from 'react';

const ChristmasMusic = () => {
  const audioRef = useRef(null);

  useEffect(() => {
    const audio = audioRef.current;
    if (audio) {
      audio.volume = 0.5;

      const attemptPlay = async () => {
        try {
          await audio.play();
          // Якщо запустилось, видаляємо всі лісенери
          removeInteractionListeners();
        } catch (e) {
          // Ігноруємо помилку, чекаємо інтеракції
        }
      };

      const handleInteraction = () => {
        attemptPlay();
      };

      const removeInteractionListeners = () => {
        document.removeEventListener('click', handleInteraction);
        document.removeEventListener('touchstart', handleInteraction);
        document.removeEventListener('keydown', handleInteraction);
        document.removeEventListener('mousemove', handleInteraction);
        document.removeEventListener('scroll', handleInteraction);
      };

      // Спробуємо одразу
      attemptPlay();

      // Додаємо купу лісенерів на будь-який рух, щоб запустити якомога раніше
      document.addEventListener('click', handleInteraction, { once: true });
      document.addEventListener('touchstart', handleInteraction, { once: true });
      document.addEventListener('keydown', handleInteraction, { once: true });
      document.addEventListener('mousemove', handleInteraction, { once: true });
      document.addEventListener('scroll', handleInteraction, { once: true });

      return () => {
        removeInteractionListeners();
      };
    }
  }, []);

  return (
    <div>
      <audio
        ref={audioRef}
        loop
        preload="auto"
        autoPlay
        muted={false}
      >
        <source src="/Bobby%20Helms%20-%20Jingle%20Bell%20Rock.mp3" type="audio/mpeg" />
        <source src="https://www.soundjay.com/misc/sounds/bell-ringing-05.wav" type="audio/wav" />
        <source src="https://www.learningcontainer.com/wp-content/uploads/2020/02/Kalimba.mp3" type="audio/mpeg" />
        Ваш браузер не підтримує аудіо елемент.
      </audio>
    </div>
  );
};

export default ChristmasMusic;